import { SnowplowHelper } from '../helpers/snowplow_helper';

class WrappedProvider {
  config: any;

  static configKey: string = 'wrappedProvider';
  static isApprovedProvider: boolean = false;
  static providerName: string = 'Wrapped Provider';

  constructor(config: any) {
    this.config = config;
  }

  load(_snowplowHelper: SnowplowHelper | null = null) {
    this.throwUnimplemented();
  }

  identify(_data: any) {
    this.throwUnimplemented();
  }

  group(_data: any) {
    this.throwUnimplemented();
  }

  page(_data: any) {
    this.throwUnimplemented();
  }

  track(_data: any) {
    this.throwUnimplemented();
  }

  throwUnimplemented() {
    throw new Error(`Implement in ${this.constructor.name}`);
  }
}

export default WrappedProvider;
